import { Button, Card, Col, Flex, Form, Input, InputNumber, Row, Select, Space } from 'antd';
import { Fragment, useCallback, useEffect, useMemo, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { notifyError, notifySuccess } from '../../../store/utils';
import { API } from '../../../api';
import CustomerSelect from '../../../lib/CustomerSelect';
import axios from 'axios';

const TariffUpdate = () => {
  const { tariffNo } = useParams();
  const [form] = Form.useForm();
  const [customer, setCustomer] = useState<any>();

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState<any>({
    branchAreas: [],
    weigthtypes: [],
    deliveryTypes: [],
  });

  const getData = useCallback(async () => {
    try {
      const [branchArea, weigthtype, deliveryType] = await Promise.all([
        await API.get({ apiVersion: 'api' })(`/settings/branch_area/list`),
        await API.get({ apiVersion: 'api' })(`/settings/weigthtype/list`),
        await API.get({ apiVersion: 'api' })(`/settings/delivery_type`),
      ]);
      console.log(deliveryType);
      return {
        branchArea,
        weigthtype,
        deliveryType,
      };
    } catch (error: any) {
      notifyError(error.message);
    }
  }, []);

  const sync = useCallback(async () => {
    try {
      const values = form.getFieldsValue();
      console.log(customer);
      console.log(values);
      const {
        data: {
          result: {
            tariff: { areaList },
          },
        },
      } = await axios.get(`http://localhost:8091/api/settings/tariff1/${customer.cd}`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const areas = (values.areas || []).map((area: any) => {
        const oldArea = areaList.find((it: any) => it.areaNo === area.no);
        console.log(oldArea);
        return {
          ...area,
          types: (area.types || []).map((type: any) => {
            const amt = (oldArea?.detailList || []).find(
              (mm: any) => mm.weightTypeNo === type.weigthTypeNo
            );
            return {
              ...type,
              amount: amt?.amount || 0,
            };
          }),
        };
      });
      form.setFieldValue('areas', areas);
    } catch (error: any) {
      notifyError(error.message);
    }
  }, [form, customer]);

  const getFormData = useCallback(async () => {
    const { branchArea, weigthtype, deliveryType }: any = await getData();
    console.log(deliveryType);
    setFormData({
      branchAreas: branchArea?.result?.data,
      weigthtypes: weigthtype?.result?.data || [],
      deliveryTypes: deliveryType.result || [],
    });
  }, []);

  const fetchTariff = useCallback(async () => {
    try {
      const [data, tariff] = await Promise.all([
        await getData(),
        await API.get({ apiVersion: 'api' })(`/settings/tariff/${tariffNo}`),
      ]);

      const deliveryType = (data?.branchArea?.result?.data || []).find(
        (it: any) => it.no === tariff?.result?.data?.branchArea?.no
      );
      const areas = (deliveryType?.areas || [])
        .sort((a: any, b: any) => a.no - b.no)
        .map((area: any) => {
          return {
            no: area.no,
            title: area.name,
            types: (data?.weigthtype?.result?.data || []).map((type: any) => {
              const item = (tariff?.result?.data?.detail || []).find(
                (it: any) => it?.weightType?.no === type.no && it?.courierArea?.no === area.no
              );
              return {
                areaNo: area.no,
                weigthTypeNo: type.no,
                name: type.name,
                amount: item?.amount,
              };
            }),
          };
        });
      console.log(areas);
      setFormData({
        branchAreas: data?.branchArea?.result?.data,
        weigthtypes: data?.weigthtype?.result?.data || [],
        deliveryTypes: data?.deliveryType?.result || [],
      });
      form.setFieldsValue({
        name: tariff?.result?.data?.name,
        type: tariff?.result?.data?.customer ? 'CUSTOMER' : 'DEFUALT',
        deliveryType: tariff?.result?.deliveryType?.code || 'HOMEDELIVERY',
        customerNo: tariff?.result?.data?.customer?.no,
        branchAreaNo: tariff?.result?.data?.branchArea?.no,
        areas,
      });
      if (tariff?.result?.data?.customer) {
        setCustomer(tariff?.result?.data?.customer);
      }
    } catch (error: any) {
      notifyError(error.message);
    }
  }, [tariffNo]);

  const changeDelivery = useCallback(
    (value: number) => {
      const deliveryArea: any = formData?.branchAreas.find((it: any) => it.no === value);
      const areas = (deliveryArea?.areas || []).map((area: any) => {
        return {
          no: area.no,
          title: area.name,
          types: (formData?.weigthtypes || []).map((type: any) => {
            return {
              areaNo: area.no,
              weigthTypeNo: type.no,
              name: type.name,
              amount: undefined,
            };
          }),
        };
      });
      form.setFieldsValue({
        areas,
      });
    },
    [formData, form]
  );

  const onFinish = useCallback(
    async (values: any) => {
      try {
        setLoading(true);
        const payload = {
          branchAreaNo: values.branchAreaNo,
          name: values.name,
          deliveryType: values.deliveryType,
          customerNo: values.type === 'CUSTOMER' ? values.customerNo : null,
          areas: values.areas.map((area: any) => {
            return {
              areaNo: area.no,
              types: area.types.map((type: any) => {
                return {
                  weigthTypeNo: type.weigthTypeNo,
                  amount: type.amount,
                };
              }),
            };
          }),
        };
        if (tariffNo) {
          await API.put({ apiVersion: 'api' })(`/settings/tariff/update/${tariffNo}`, payload);
        } else {
          await API.post({ apiVersion: 'api' })(`/settings/tariff/create`, payload);
        }
        notifySuccess('Амжилттай хадгаллаа');
      } catch (error: any) {
        notifyError(error.message);
      } finally {
        setLoading(false);
      }
    },
    [tariffNo]
  );

  useEffect(() => {
    if (tariffNo) {
      fetchTariff();
    } else {
      getFormData();
    }
  }, [tariffNo]);

  const deliveryTypeOptions = useMemo(() => {
    let options = formData?.deliveryTypes.map((pt: any) => {
      return {
        label: pt.text,
        value: pt.code,
      };
    });

    return options;
  }, [formData]);

  return (
    <Card title={tariffNo ? `Тариф засах` : `Тариф нэмэх`}>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Row>
          <Col span={16}>
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item
                  name="name"
                  label="Тариф нэр"
                  rules={[{ required: true, message: 'Тариф нэр оруулна уу' }]}
                >
                  <Input placeholder="Тариф нэр оруулна уу" />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="deliveryType"
                  label="Хүргэлтийн төрөл"
                  rules={[{ required: true, message: 'Хүргэлтийн төрөл сонгоно уу' }]}
                >
                  <Select placeholder="Хүргэлтийн төрөл сонгоно уу" options={deliveryTypeOptions} />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="type"
                  label="Тариф төрөл"
                  rules={[{ required: true, message: 'Тариф төрөл сонгоно уу' }]}
                >
                  <Select disabled={!!tariffNo} placeholder="Тариф төрөл сонгоно уу">
                    <Select.Option value="DEFUALT">Суурь үнэ</Select.Option>
                    <Select.Option value="CUSTOMER">Харилцагч</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="branchAreaNo"
                  label="Хүргэлт"
                  rules={[{ required: true, message: 'Хүргэлт сонгоно уу' }]}
                >
                  <Select
                    disabled={!!tariffNo}
                    placeholder="Хүргэлт сонгоно уу"
                    onChange={(value) => changeDelivery(value)}
                    options={(formData?.branchAreas || []).map((item: any) => {
                      return {
                        label: item.name,
                        value: item.no,
                      };
                    })}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  noStyle
                  shouldUpdate={(prevValues, currentValues) =>
                    prevValues.type !== currentValues.type
                  }
                >
                  {({ getFieldValue }) =>
                    getFieldValue('type') === 'CUSTOMER' ? (
                      <Form.Item
                        name="customerNo"
                        label="Харилцагч"
                        rules={[{ required: true, message: 'Харилцагч сонгоно уу' }]}
                      >
                        <CustomerSelect
                          allowClear
                          showSearch
                          customer={customer}
                          disabled={!!tariffNo}
                        />
                      </Form.Item>
                    ) : null
                  }
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  noStyle
                  shouldUpdate={(prevValues, currentValues) =>
                    prevValues.branchAreaNo !== currentValues.branchAreaNo
                  }
                >
                  {({ getFieldValue }) =>
                    getFieldValue('branchAreaNo') ? (
                      <Row>
                        <Form.List name="areas">
                          {(fields, { add, remove }) => {
                            return (
                              <Fragment>
                                {fields.map((field) => {
                                  return (
                                    <Col key={`area_item_${field.key}`} span={12}>
                                      <Flex vertical>
                                        <div>
                                          <Form.Item name={[field.name, 'no']} hidden={true}>
                                            <Input disabled />
                                          </Form.Item>
                                          <Form.Item name={[field.name, 'title']}>
                                            <Input className="title-input" disabled />
                                          </Form.Item>
                                        </div>
                                        <div>
                                          <Form.List name={[field.name, 'types']}>
                                            {(subFields, subOpt) => (
                                              <div
                                                style={{
                                                  display: 'flex',
                                                  flexDirection: 'column',
                                                  rowGap: 16,
                                                }}
                                              >
                                                {subFields.map((subField) => (
                                                  <Flex
                                                    justify="center"
                                                    align="center"
                                                    key={subField.key}
                                                  >
                                                    <Form.Item
                                                      noStyle
                                                      name={[subField.name, 'areaNo']}
                                                      hidden={true}
                                                    >
                                                      <Input />
                                                    </Form.Item>
                                                    <Form.Item
                                                      noStyle
                                                      name={[subField.name, 'weigthTypeNo']}
                                                      hidden={true}
                                                    >
                                                      <Input />
                                                    </Form.Item>
                                                    <Form.Item name={[subField.name, 'name']}>
                                                      <Input
                                                        disabled
                                                        className="title-input text-right"
                                                      />
                                                    </Form.Item>
                                                    <div
                                                      style={{
                                                        marginBottom: 24,
                                                        paddingLeft: 8,
                                                        paddingRight: 8,
                                                      }}
                                                    >
                                                      {' '}
                                                      :{' '}
                                                    </div>
                                                    <Form.Item
                                                      name={[subField.name, 'amount']}
                                                      rules={[
                                                        {
                                                          required: true,
                                                          message: 'Үнэ оруулна уу',
                                                        },
                                                      ]}
                                                    >
                                                      <InputNumber placeholder="Үнэ" />
                                                    </Form.Item>
                                                  </Flex>
                                                ))}
                                              </div>
                                            )}
                                          </Form.List>
                                        </div>
                                      </Flex>
                                    </Col>
                                  );
                                })}
                              </Fragment>
                            );
                          }}
                        </Form.List>
                      </Row>
                    ) : null
                  }
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={16}>
            <Form.Item>
              <Flex justify="end" gap={24}>
                <Link to={`/settings/tariff?page=1&size=10`}>
                  <Button htmlType="button">Буцах</Button>
                </Link>
                <Button loading={loading} type="primary" htmlType="submit">
                  Хадгалах
                </Button>
              </Flex>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};

export default TariffUpdate;
